import { InputAdornment, TextField } from '@material-ui/core'
import { actions, useDispatch } from '@/redux'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import TableSearchForm from '@/components/Table/TableSearchForm'
import hooks from '@/hooks'

const defaultState = {
  page: 1,
  memo: '',
  mobile: '',
  admin: '',
  startedAt: '',
  endedAt: '',
}

/**
 *
 * @param {*} props
 * @returns
 */
export default function RiceCoinSearchForm (props) {
  const dispatch = useDispatch()
  const classes = useStyles(props)
  const [inputState, setInputState] = React.useState(defaultState)
  const params = hooks.riceCoin.useQueryParams()

  React.useEffect(() => {
    if (params) {
      setInputState(params)
    }
  }, [params])

  const handleChange = (event) => {
    const { name, value } = event.currentTarget
    setInputState(prev => { return { ...prev, [name]: value } })
  }

  const handleSearch = async (event) => {
    event.preventDefault()

    await dispatch(actions.riceCoin.updateQuery({ ...inputState, page: 1 }))
    dispatch(actions.riceCoin.getLedgers())
  }

  const handleClear = (event) => {
    event.preventDefault()
    dispatch(actions.riceCoin.updateQuery(defaultState))
  }

  return (
    <TableSearchForm
      handleSearch={handleSearch}
      handleClear={handleClear}
    >
      <TextField
        label='Mobile'
        name='mobile'
        type='tel'
        variant='outlined'
        size='small'
        fullWidth
        classes={{ root: classes.textField }}
        value={inputState.mobile}
        onChange={handleChange}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSearch(e)
          }
        }}
        InputProps={{ startAdornment: <InputAdornment position='start'>+852</InputAdornment> }}
      />
      <TextField
        label='Memo'
        name='memo'
        type='text'
        variant='outlined'
        size='small'
        fullWidth
        classes={{ root: classes.textField }}
        value={inputState.memo}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSearch(e)
          }
        }}
        onChange={handleChange}
      />
      <TextField
        label='Admin'
        name='admin'
        type='text'
        variant='outlined'
        size='small'
        fullWidth
        classes={{ root: classes.textField }}
        value={inputState.admin}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSearch(e)
          }
        }}
        onChange={handleChange}
      />
      <TextField
        label='Start date'
        name='startedAt'
        type='date'
        variant='outlined'
        size='small'
        fullWidth
        classes={{ root: classes.textField }}
        value={inputState.startedAt}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSearch(e)
          }
        }}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <TextField
        label='End date'
        name='endedAt'
        type='date'
        variant='outlined'
        size='small'
        fullWidth
        classes={{ root: classes.textField }}
        value={inputState.endedAt}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSearch(e)
          }
        }}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </TableSearchForm>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gap: theme.spacing(2),
    margin: theme.spacing(1, 0),
  },
  textField: {
    background: theme.palette.common.white,
  },
  actions: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gap: theme.spacing(1),
  },
  fileds: {
    display: 'grid',
    gridTemplateRows: 'auto',
    gap: theme.spacing(1),
  },
}))
